import axios from "axios";

const getProjects = async () => {
    const response = await axios.get('/api/archive-articles/projects');
    return response.data;
}

const previewArticle = async (project_id, input) => {
    const response = await axios.post('/api/archive-articles/preview', { project_id, input });
    return response.data;
}

const deleteArticle = async (project_id, input) => {
    const response = await axios.post('/api/archive-articles/delete', { project_id, input });
    return response.data;
}

export default {
    getProjects,
    previewArticle,
    deleteArticle
}
